import { render, staticRenderFns } from "./EventActivityField.vue?vue&type=template&id=1d153684&scoped=true"
import script from "./EventActivityField.vue?vue&type=script&lang=js"
export * from "./EventActivityField.vue?vue&type=script&lang=js"
import style0 from "./EventActivityField.vue?vue&type=style&index=0&id=1d153684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d153684",
  null
  
)

export default component.exports